<template>
  <div class="con">
    北京运多多网络科技有限公司创始于2015年7月，联合创始人均来自阿里巴巴、360公司、百度、摇篮网和SYNNEX等知名公司。
    公司致力于科技、互联网传统相关业务模式，基于互联网思维，为B、C端用户提供服务，旗下产品有京东区域营销、洗爱车、天天向上等知名产品。目前深度合作了京东、阳光海天全国最大洗车服务平台、易车生活、博众博悦等精准的战略伙伴与资源。
  </div>
</template>

<script>
export default {
  data () {
    return {
      dcode: ''
    }
  },
  methods: {
    getShopDcode(){
      this.$post("/app/v2/shop/shopInfo",{userId: 100445})
        .then((response) => {
          console.log(response);
          this.dcode =  response.data.qrcode
        })
    },
  },
  mounted: function () {
    this.getShopDcode();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {}


</style>



// WEBPACK FOOTER //
// src/components/children/aboutme.vue